import { render, staticRenderFns } from "./VisitMaterialRowsTable.vue?vue&type=template&id=466544b2&scoped=true"
import script from "./VisitMaterialRowsTable.vue?vue&type=script&lang=js"
export * from "./VisitMaterialRowsTable.vue?vue&type=script&lang=js"
import style0 from "./VisitMaterialRowsTable.vue?vue&type=style&index=0&id=466544b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466544b2",
  null
  
)

export default component.exports